import { render, staticRenderFns } from "./CreateJob.vue?vue&type=template&id=2ac9f6a4&scoped=true&"
import script from "./CreateJob.vue?vue&type=script&lang=js&"
export * from "./CreateJob.vue?vue&type=script&lang=js&"
import style0 from "./CreateJob.vue?vue&type=style&index=0&id=2ac9f6a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac9f6a4",
  null
  
)

export default component.exports